import { getData, postData } from '../utils/api';

export const getOrders = async ({
  page = 1,
  limit = 15,
  sortField = 'updatedAt',
  sortValue = 'DESC',
  searchKey = '',
  postingAccount = '',
  zone = '',
  state = '',
  status = '',
  startDate = '',
  endDate = '',
  fetchType = 'order'
}) => {
  try {
    // Choose API route based on fetchType
    const baseUrl = fetchType === 'order' ? '/data/order/aggregated-orders' : '/data/order';

    let url = `${baseUrl}?page=${page}&limit=${limit}&sortField=${sortField}&sortValue=${sortValue}`;

    // Add optional parameters if they have values
    if (searchKey) url += `&searchKey=${encodeURIComponent(searchKey)}`;
    if (postingAccount) url += `&postingAccount=${encodeURIComponent(postingAccount)}`;
    if (zone) url += `&zone=${encodeURIComponent(zone)}`;
    if (state) url += `&state=${encodeURIComponent(state)}`;
    if (status) url += `&status=${encodeURIComponent(status)}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;

    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFixOrderEntries = async ({
  page = 1,
  limit = 15,
  sortField = 'id',
  sortValue = 'ASC',
  issueType = 'duplicates',
}) => {
  try {
    const url = `/data/order/fix-entries?page=${page}&limit=${limit}&sortField=${encodeURIComponent(sortField)}&sortValue=${encodeURIComponent(sortValue)}&issueType=${encodeURIComponent(issueType)}`;
    const response = await getData(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeDuplicateOrderEntries = async () => {
  try {
    const response = await postData('/data/order/fix-entries/remove-duplicates');
    return response;
  } catch (error) {
    throw error;
  }
}; 